import ApolloClient, { gql } from 'apollo-boost';

const client = new ApolloClient({
  uri: 'https://graphqlzero.almansi.me/api'
});
client.query({ query: gql`
query {
    post(id: 5) {
      title
      body
    }
  }
`}).then(console.log);
// { "data": { "user": { ... } } }